package com.eladfinish.bible.contest.screens.openQuestions.ui.dialogs

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardCapitalization
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import com.eladfinish.bible.contest.screens.openQuestions.AddQuestionFormField
import com.eladfinish.bible.contest.screens.openQuestions.OpenQuestionsAction
import com.eladfinish.bible.contest.screens.openQuestions.OpenQuestionsState.DialogState.AddQuestion
import com.eladfinish.bible.contest.ui.components.dialogs.TextInputAlertDialog
import com.eladfinish.bible.contest.ui.layout.isKeyboardCoveringShortWindow

@Composable
internal fun AddQuestionDialog(
    state: AddQuestion,
    onAction: (OpenQuestionsAction) -> Unit,
    onDismiss: () -> Unit,
) {
    TextInputAlertDialog(
        title = "הוספת שאלה",
        onDismissRequest = { if (!state.isSubmitting) onDismiss() },
        buttons = {
            TextButton(
                onClick = onDismiss,
                enabled = !state.isSubmitting,
            ) { Text("ביטול") }
            if (state.isSubmitting) {
                CircularProgressIndicator(modifier = Modifier.padding(8.dp))
            } else {
                TextButton(onClick = { onAction(OpenQuestionsAction.SubmitAddQuestion) }) {
                    Text("שלח")
                }
            }
        },
    ) {
        if (!isKeyboardCoveringShortWindow()) {
            Text(
                text = "אם השאלה מתאימה, היא תתווסף למאגר השאלות.\nניתן לקבל קרדיט על ידי הזנת שם ודוא\"ל.",
                modifier = Modifier.padding(bottom = 12.dp),
            )
        }
        AddQuestionField(
            label = "שאלה *",
            value = state.question,
            field = AddQuestionFormField.QUESTION,
            singleLine = false,
            onAction = onAction,
        )
        AddQuestionField(
            label = "תשובה *",
            value = state.answer,
            field = AddQuestionFormField.ANSWER,
            onAction = onAction,
        )
        AddQuestionField(
            label = "שם פרטי",
            value = state.firstName,
            field = AddQuestionFormField.FIRST_NAME,
            onAction = onAction,
        )
        AddQuestionField(
            label = "שם משפחה",
            value = state.lastName,
            field = AddQuestionFormField.LAST_NAME,
            onAction = onAction,
        )
        AddQuestionField(
            label = "דוא\"ל",
            value = state.email,
            field = AddQuestionFormField.EMAIL,
            keyboardType = KeyboardType.Email,
            imeAction = ImeAction.Done,
            onAction = onAction,
        )
    }
}

@Composable
private fun AddQuestionField(
    label: String,
    value: String,
    field: AddQuestionFormField,
    onAction: (OpenQuestionsAction) -> Unit,
    singleLine: Boolean = true,
    keyboardType: KeyboardType = KeyboardType.Text,
    imeAction: ImeAction = ImeAction.Next,
) {
    OutlinedTextField(
        value = value,
        onValueChange = { onAction(OpenQuestionsAction.AddQuestionFieldChanged(field, it)) },
        label = { Text(label) },
        modifier = Modifier
            .fillMaxWidth()
            .padding(vertical = 4.dp),
        singleLine = singleLine,
        keyboardOptions = KeyboardOptions(
            capitalization = KeyboardCapitalization.Sentences,
            keyboardType = keyboardType,
            imeAction = imeAction,
        ),
    )
}
